var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinkCircleDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-538.036 -480.539 309.968 307.264",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__b",
    x1: 157.8,
    y1: 106.46,
    x2: 170.7,
    y2: 106.46,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__a",
    x1: 1282.92,
    y1: 366.33,
    x2: 1295.82,
    y2: 366.33,
    gradientUnits: "userSpaceOnUse",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa95ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de3163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__c",
    x1: 211.2,
    y1: 270.31,
    x2: 219.61,
    y2: 270.31,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__d",
    x1: 41.73,
    y1: 249.2,
    x2: 49.76,
    y2: 249.2,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__e",
    x1: 151.49,
    y1: 78.36,
    x2: 159.83,
    y2: 78.36,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__f",
    x1: 325.2,
    y1: 206.72,
    x2: 337.12,
    y2: 206.72,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__g",
    x1: 65.89,
    y1: 130.37,
    x2: 76.69,
    y2: 130.37,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__h",
    x1: 75.37,
    y1: 304.79,
    x2: 89.14,
    y2: 304.79,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__i",
    x1: 133.92,
    y1: 250.96,
    x2: 141.58,
    y2: 250.96,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__j",
    x1: 181.88,
    y1: 374.55,
    x2: 196.13,
    y2: 374.55,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__k",
    x1: 256.21,
    y1: 194.9,
    x2: 270.31,
    y2: 194.9,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__l",
    x1: 141.62,
    y1: 124.94,
    x2: 149.1,
    y2: 124.94,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__m",
    x1: 142.04,
    y1: 301.91,
    x2: 155.39,
    y2: 301.91,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__n",
    x1: 250.37,
    y1: 276.3,
    x2: 260.56,
    y2: 276.3,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__o",
    x1: 159.49,
    y1: 326.6,
    x2: 167.74,
    y2: 326.6,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__p",
    x1: 289,
    y1: 135.68,
    x2: 298.78,
    y2: 135.68,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__q",
    x1: 284.34,
    y1: 267.44,
    x2: 292.64,
    y2: 267.44,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__r",
    x1: 239.13,
    y1: 361.99,
    x2: 251.33,
    y2: 361.99,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__s",
    x1: 60.37,
    y1: 234.48,
    x2: 71.6,
    y2: 234.48,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__t",
    x1: 202.52,
    y1: 240.76,
    x2: 211.01,
    y2: 240.76,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__u",
    x1: 120.72,
    y1: 277.89,
    x2: 128.93,
    y2: 277.89,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__v",
    x1: 78.54,
    y1: 255.29,
    x2: 93.63,
    y2: 255.29,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__w",
    x1: 268.47,
    y1: 241.49,
    x2: 275.76,
    y2: 241.49,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__x",
    x1: 123.44,
    y1: 220.88,
    x2: 133.7,
    y2: 220.88,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__y",
    x1: 135.96,
    y1: 154.72,
    x2: 151.41,
    y2: 154.72,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__z",
    x1: 178.99,
    y1: 347.52,
    x2: 186.64,
    y2: 347.52,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__A",
    x1: 205.6,
    y1: 151.49,
    x2: 213.44,
    y2: 151.49,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__B",
    x1: 291.76,
    y1: 198.13,
    x2: 301.24,
    y2: 198.13,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__C",
    x1: 60.09,
    y1: 185.2,
    x2: 69.21,
    y2: 185.2,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__D",
    x1: 93.13,
    y1: 101.66,
    x2: 100.56,
    y2: 101.66,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__E",
    x1: 268.55,
    y1: 303.86,
    x2: 283.83,
    y2: 303.86,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__F",
    x1: 109.92,
    y1: 188.04,
    x2: 121.56,
    y2: 188.04,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__G",
    x1: 314.93,
    y1: 234.64,
    x2: 324.23,
    y2: 234.64,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__H",
    x1: 163.35,
    y1: 237.91,
    x2: 170.84,
    y2: 237.91,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__I",
    x1: 62.41,
    y1: 159.19,
    x2: 72,
    y2: 159.19,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__J",
    x1: 208.65,
    y1: 183.78,
    x2: 217.4,
    y2: 183.78,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__K",
    x1: 34.08,
    y1: 210.2,
    x2: 46.1,
    y2: 210.2,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__L",
    x1: 214.45,
    y1: 123.83,
    x2: 225.68,
    y2: 123.83,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__M",
    x1: 235.31,
    y1: 244.64,
    x2: 242.46,
    y2: 244.64,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__N",
    x1: 175.55,
    y1: 291.32,
    x2: 186.62,
    y2: 291.32,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__O",
    x1: 207.23,
    y1: 82.95,
    x2: 215.1,
    y2: 82.95,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__P",
    x1: 110.28,
    y1: 158.04,
    x2: 120.31,
    y2: 158.04,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__Q",
    x1: 266.6,
    y1: 164.12,
    x2: 273.87,
    y2: 164.12,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__R",
    x1: 86.54,
    y1: 171.9,
    x2: 94.29,
    y2: 171.9,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__S",
    x1: 218.31,
    y1: 334.96,
    x2: 227.29,
    y2: 334.96,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__T",
    x1: 317.14,
    y1: 259.57,
    x2: 329.38,
    y2: 259.57,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__U",
    x1: 233.52,
    y1: 96.84,
    x2: 245.68,
    y2: 96.84,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__V",
    x1: 288.38,
    y1: 225.55,
    x2: 301.03,
    y2: 225.55,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__W",
    x1: 311.18,
    y1: 172.73,
    x2: 320.22,
    y2: 172.73,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__X",
    x1: 153.1,
    y1: 213.56,
    x2: 161.08,
    y2: 213.56,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__Y",
    x1: 105.99,
    y1: 318.21,
    x2: 116.16,
    y2: 318.21,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__Z",
    x1: 240.53,
    y1: 215.21,
    x2: 255.52,
    y2: 215.21,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__aa",
    x1: 39.73,
    y1: 155.42,
    x2: 46.48,
    y2: 155.42,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ab",
    x1: 203.03,
    y1: 361.5,
    x2: 218.6,
    y2: 361.5,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ac",
    x1: 172.09,
    y1: 181.01,
    x2: 185.84,
    y2: 181.01,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ad",
    x1: 152.11,
    y1: 274.05,
    x2: 163.49,
    y2: 274.05,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ae",
    x1: 303.15,
    y1: 291.13,
    x2: 316.16,
    y2: 291.13,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__af",
    x1: 114.31,
    y1: 118.04,
    x2: 126.24,
    y2: 118.04,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ag",
    x1: 69.28,
    y1: 209.1,
    x2: 80.16,
    y2: 209.1,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ah",
    x1: 213.74,
    y1: 296.96,
    x2: 225.8,
    y2: 296.96,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ai",
    x1: 128.24,
    y1: 336.48,
    x2: 137.85,
    y2: 336.48,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__aj",
    x1: 238.13,
    y1: 306.49,
    x2: 248.94,
    y2: 306.49,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ak",
    x1: 206.54,
    y1: 213.34,
    x2: 214.4,
    y2: 213.34,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__al",
    x1: 103.65,
    y1: 243.6,
    x2: 116.29,
    y2: 243.6,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__am",
    x1: 90.13,
    y1: 282.57,
    x2: 101.02,
    y2: 282.57,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__an",
    x1: 123,
    y1: 87.85,
    x2: 135.14,
    y2: 87.85,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ao",
    x1: 96.32,
    y1: 135.98,
    x2: 103.4,
    y2: 135.98,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ap",
    x1: 172.72,
    y1: 139.74,
    x2: 180.02,
    y2: 139.74,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__aq",
    x1: 93.5,
    y1: 215.44,
    x2: 107.02,
    y2: 215.44,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ar",
    x1: 145.75,
    y1: 186.75,
    x2: 154.85,
    y2: 186.75,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__as",
    x1: 251.95,
    y1: 118.25,
    x2: 258.92,
    y2: 118.25,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__at",
    x1: 27.15,
    y1: 183.56,
    x2: 33.78,
    y2: 183.56,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__au",
    x1: 281.86,
    y1: 331.23,
    x2: 291.6,
    y2: 331.23,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__av",
    x1: 54.79,
    y1: 277.2,
    x2: 69.32,
    y2: 277.2,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__aw",
    x1: 192.46,
    y1: 110.11,
    x2: 203.47,
    y2: 110.11,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ax",
    x1: 188.99,
    y1: 316.55,
    x2: 198.33,
    y2: 316.55,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__ay",
    x1: 176.36,
    y1: 81.81,
    x2: 191.37,
    y2: 81.81,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__az",
    x1: 251.97,
    y1: 333.11,
    x2: 260.8,
    y2: 333.11,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__aA",
    x1: 178.58,
    y1: 261.02,
    x2: 192.64,
    y2: 261.02,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__aB",
    x1: 148.67,
    y1: 359.86,
    x2: 161.16,
    y2: 359.86,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pink-circle-dots_svg__aC",
    x1: 240.76,
    y1: 151.62,
    x2: 248.8,
    y2: 151.62,
    xlinkHref: "#pink-circle-dots_svg__a",
    fill: "#000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-88",
    d: "M162.3 112.37a26.31 26.31 0 004.46-.5c2.7-.8 3.48-3.19 3.89-5.71.59-3.66-4.24-5.86-8.2-5.62-6.79.46-5.53 10.3-.15 11.83z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-89",
    d: "M211.28 271.21a18.6 18.6 0 001.73 2.57c1.35 1.39 3.06 1.11 4.73.56 2.43-.81 2.24-4.47.83-6.82-2.42-4.02-8.08-.09-7.29 3.69z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-90",
    d: "M42.27 251.38a17.12 17.12 0 002.34 1.62c1.62.76 3 0 4.28-1.07 1.84-1.49.47-4.6-1.52-6.17-3.37-2.65-7.02 2.6-5.1 5.62z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-91",
    d: "M153 81.63a16.57 16.57 0 002.82.76c1.82.16 2.87-1.1 3.72-2.53 1.23-2.07-1.16-4.56-3.62-5.36-4.25-1.37-5.86 4.92-2.92 7.13z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-92",
    d: "M326.31 210.43a24.46 24.46 0 003.68 2.08c2.51.88 4.42-.52 6.12-2.22 2.48-2.47 0-6.82-3.16-8.82-5.42-3.42-9.95 4.83-6.64 8.96z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-93",
    d: "M68 134.76a21.9 21.9 0 003.69.79c2.37.09 3.63-1.6 4.63-3.5 1.46-2.76-1.8-5.81-5-6.68-5.53-1.49-7.19 6.73-3.32 9.39z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__g)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-94",
    d: "M79.9 311.07a27.64 27.64 0 004.77-.35c2.91-.74 3.84-3.25 4.39-5.93.78-3.88-4.28-6.43-8.51-6.33-7.26.16-6.33 10.76-.65 12.61z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__h)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-95",
    d: "M134.93 253.68a15.46 15.46 0 002.49 1c1.66.36 2.76-.67 3.7-1.89 1.37-1.75-.54-4.31-2.7-5.33-3.7-1.72-5.89 3.86-3.49 6.22z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__i)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-96",
    d: "M185.53 380.81a29.72 29.72 0 004.95.37c3.1-.31 4.43-2.75 5.4-5.4 1.4-3.86-3.39-7.25-7.75-7.8-7.47-.98-8.13 10.02-2.6 12.83z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__j)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-97",
    d: "M256.21 194.83c0 .77 1.94 4.84 2 4.89 1.75 2.8 4.7 2.93 7.68 2.6 4.33-.47 5.3-6.63 3.78-11-2.67-7.58-13.43-3.05-13.46 3.51z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__k)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-98",
    d: "M141.63 124.4a15.59 15.59 0 00.74 2.71c.75 1.59 2.3 1.84 3.9 1.85 2.32 0 3.22-3.18 2.69-5.6-.91-4.16-6.91-2.43-7.33 1.04z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__l)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-99",
    d: "M145.29 307.68a27.42 27.42 0 004.63.48c2.91-.21 4.22-2.46 5.2-4.92 1.41-3.58-3-6.88-7.06-7.51-6.97-1.08-7.88 9.27-2.77 11.95z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__m)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-100",
    d: "M250.42 277.14a23 23 0 002 3.22c1.56 1.78 3.66 1.53 5.72 1 3-.84 3-5.29 1.41-8.23-2.76-5.07-9.86-.64-9.13 4.01z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__n)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-101",
    d: "M160.56 329.53a17.21 17.21 0 002.69 1.1c1.78.39 3-.72 4-2 1.48-1.9-.57-4.66-2.9-5.75-3.99-1.88-6.35 4.12-3.79 6.65z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__o)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-102",
    d: "M289.31 137.59a20 20 0 002.49 2.53c1.81 1.29 3.67.61 5.44-.36 2.58-1.42 1.59-5.5-.49-7.84-3.58-4.03-9.12 1.58-7.44 5.67z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__p)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-103",
    d: "M285.89 270.77a17.51 17.51 0 002.83.67c1.82.11 2.82-1.17 3.62-2.62 1.17-2.09-1.28-4.5-3.75-5.22-4.22-1.25-5.59 5.05-2.7 7.17z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__q)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-104",
    d: "M239.13 361.83a26.16 26.16 0 001.64 4.26c1.49 2.44 4 2.59 6.62 2.34 3.76-.36 4.67-5.68 3.41-9.51-2.17-6.57-11.57-2.77-11.67 2.91z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__r)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-105",
    d: "M60.92 237.16a22.87 22.87 0 003.1 2.59c2.19 1.26 4.23.29 6.13-1 2.75-1.89 1.19-6.4-1.43-8.83-4.49-4.18-10.15 2.79-7.8 7.24z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__s)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-106",
    d: "M202.65 242a18.62 18.62 0 001.91 2.45c1.45 1.31 3.14.91 4.78.24 2.38-1 1.94-4.62.36-6.88-2.7-3.91-8.09.41-7.05 4.19z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__t)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-107",
    d: "M121.2 280a17.29 17.29 0 002.34 1.78c1.65.85 3.09.07 4.43-.94 1.94-1.47.65-4.7-1.34-6.38-3.4-2.87-7.29 2.38-5.43 5.54z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__u)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-108",
    d: "M80.85 260.94c.58.51 5 1.68 5 1.69 3.29.5 5.31-1.66 7-4.16 2.47-3.62-1.59-8.39-5.95-10.11-7.44-2.95-11.04 8.26-6.05 12.58z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__v)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-109",
    d: "M269.09 243.67a15.33 15.33 0 002.21 1.33c1.52.59 2.72-.23 3.79-1.24 1.57-1.46.13-4.17-1.76-5.46-3.26-2.19-6.17 2.78-4.24 5.37z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__w)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-110",
    d: "M125.77 225.23a20.15 20.15 0 003.54.5c2.24-.08 3.32-1.77 4.14-3.63 1.19-2.71-2.11-5.37-5.21-6-5.33-1-6.33 6.9-2.47 9.13z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__x)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-111",
    d: "M138.41 160.59c.61.5 5.11 1.63 5.17 1.64 3.37.45 5.41-1.8 7.1-4.37 2.47-3.75-1.77-8.56-6.26-10.25-7.69-2.89-11.19 8.64-6.01 12.98z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__y)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-112",
    d: "M179.43 349.47a16.53 16.53 0 002.17 1.68c1.53.79 2.88.07 4.13-.86 1.82-1.35.63-4.37-1.21-6-3.15-2.65-6.8 2.23-5.09 5.18z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__z)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-113",
    d: "M205.74 152.65a16.29 16.29 0 001.8 2.24c1.35 1.18 2.9.79 4.41.15 2.18-.93 1.72-4.29.23-6.35-2.54-3.52-7.45.54-6.44 3.96z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__A)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-114",
    d: "M293.31 201.76a18.28 18.28 0 003.18 1c2.07.26 3.3-1.14 4.32-2.73 1.49-2.31-1.15-5.23-3.91-6.23-4.73-1.75-6.8 5.34-3.59 7.96z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__B)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-115",
    d: "M60.68 187.65a17.88 17.88 0 002.65 1.9c1.84.89 3.43 0 4.88-1.18 2.1-1.68.57-5.22-1.69-7-3.86-3.1-8 2.84-5.84 6.28z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__C)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-116",
    d: "M95.58 105.05a14.4 14.4 0 002.58-.19c1.57-.4 2.07-1.76 2.36-3.2.42-2.1-2.31-3.47-4.6-3.41-3.92.09-3.4 5.81-.34 6.8z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__D)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-117",
    d: "M272.69 310.67c.71.32 5.26.23 5.31.23 3.31-.44 4.66-3.09 5.61-6 1.37-4.18-3.88-7.64-8.56-8.09-8.05-.73-8.38 11.08-2.36 13.86z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__E)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-118",
    d: "M110.29 190.31a23.59 23.59 0 003 3c2.16 1.54 4.37.73 6.48-.43 3.06-1.68 1.89-6.54-.59-9.33-4.29-4.78-10.89 1.89-8.89 6.76z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__F)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-119",
    d: "M316.94 238.53a18.71 18.71 0 003.2.53c2 0 3.05-1.52 3.84-3.2 1.14-2.43-1.79-4.92-4.59-5.53-4.81-1.06-5.9 6.07-2.45 8.2z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__G)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-120",
    d: "M163.6 239.42a16.05 16.05 0 001.93 1.9c1.4 1 2.82.43 4.16-.33 1.95-1.11 1.15-4.22-.46-6-2.78-2.99-6.95 1.32-5.63 4.43z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__H)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-121",
    d: "M64.17 163a19.42 19.42 0 003.26.81c2.1.14 3.27-1.33 4.22-3 1.37-2.41-1.45-5.22-4.29-6.08-4.87-1.45-6.56 5.81-3.19 8.27z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__I)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-122",
    d: "M208.76 184.85a19.21 19.21 0 001.88 2.61c1.45 1.4 3.21 1 4.93.42 2.5-.92 2.17-4.71.63-7.09-2.65-4.1-8.38.21-7.44 4.06z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__J)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-123",
    d: "M35.05 213.74a25.05 25.05 0 003.63 2.26c2.49 1 4.48-.32 6.28-2 2.61-2.38.31-6.88-2.79-9-5.31-3.71-10.23 4.41-7.12 8.74z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__K)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-124",
    d: "M214.59 125.24a22.7 22.7 0 002.44 3.34c1.86 1.79 4.12 1.32 6.33.5 3.19-1.2 2.75-6.06.75-9.11-3.43-5.23-10.76.28-9.52 5.27z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__L)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-125",
    d: "M235.46 245.8a15.51 15.51 0 001.69 2c1.27 1 2.67.64 4 0 2-.9 1.45-3.94.05-5.77-2.39-3.14-6.75.68-5.74 3.77z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__M)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-126",
    d: "M179.7 296.42a23.34 23.34 0 003.81-.63c2.28-.8 2.84-2.88 3.09-5.07.35-3.16-3.89-4.84-7.28-4.46-5.81.65-4.32 9.08.38 10.16z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__N)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-127",
    d: "M207.33 84a17.25 17.25 0 001.72 2.32c1.32 1.25 2.9.91 4.44.32 2.24-.85 1.9-4.25.48-6.38-2.42-3.68-7.53.22-6.64 3.74z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__O)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-128",
    d: "M110.29 156.87a21.13 21.13 0 00.73 3.71c.85 2.21 2.91 2.7 5 2.87 3.11.25 4.63-4 4.16-7.26-.77-5.67-8.98-3.94-9.89.68z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__P)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-129",
    d: "M266.6 163.71a15.88 15.88 0 00.79 2.61c.77 1.52 2.28 1.72 3.83 1.69 2.26 0 3-3.17 2.46-5.51-.99-4.01-6.76-2.17-7.08 1.21z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__Q)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-130",
    d: "M86.54 171.8a16.21 16.21 0 001 2.71c.94 1.55 2.56 1.64 4.21 1.48 2.38-.23 3-3.61 2.15-6.05-1.33-4.17-7.3-1.75-7.36 1.86z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__R)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-131",
    d: "M219.39 338a18 18 0 002.88 1.31c1.93.48 3.26-.68 4.42-2.06 1.69-2-.45-5.09-2.94-6.37-4.27-2.17-7.08 4.29-4.36 7.12z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__S)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-132",
    d: "M317.94 262.88a25.42 25.42 0 003.56 2.54c2.48 1.19 4.6 0 6.54-1.59 2.83-2.26.77-7-2.26-9.43-5.19-4.13-10.78 3.85-7.84 8.48z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__T)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-133",
    d: "M237.07 102.33a24.68 24.68 0 004.23 0c2.61-.46 3.6-2.62 4.25-4.94.94-3.36-3.35-5.94-7.09-6.13-6.4-.33-6.27 9.07-1.39 11.07z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__U)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-134",
    d: "M290.84 230.68a27.13 27.13 0 004.32.95c2.77.11 4.26-1.87 5.44-4.09 1.73-3.22-2.08-6.82-5.85-7.85-6.47-1.77-8.45 7.85-3.91 10.99z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__V)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-135",
    d: "M312.7 176.22a17.9 17.9 0 003 .89c2 .22 3.13-1.13 4.09-2.66 1.38-2.22-1.16-5-3.81-5.89-4.49-1.56-6.37 5.21-3.28 7.66z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__W)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-136",
    d: "M153.37 215.18a17.49 17.49 0 002.06 2c1.49 1 3 .45 4.43-.37 2.08-1.18 1.22-4.49-.5-6.38-2.96-3.2-7.36 1.44-5.99 4.75z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__X)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-137",
    d: "M107.35 321.84a21 21 0 003.32 1.33c2.2.46 3.65-.92 4.89-2.53 1.81-2.35-.75-5.73-3.63-7.05-4.93-2.28-7.79 5.14-4.58 8.25z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__Y)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-138",
    d: "M244.13 221.67c.67.37 5.14.58 5.19.58 3.27-.22 4.77-2.73 5.89-5.48 1.62-4-3.3-7.75-7.86-8.49-7.82-1.28-8.94 10.28-3.22 13.39z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__Z)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-139",
    d: "M39.73 154.86a13.72 13.72 0 00.64 2.46c.65 1.45 2.05 1.7 3.49 1.73 2.1 0 3-2.83 2.51-5-.76-3.79-6.2-2.32-6.64.81z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__aa)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-140",
    d: "M208.75 368.66c.77.19 5.31-.78 5.36-.79 3.23-1.08 4.06-4 4.45-7.06.57-4.44-5.36-6.89-10.13-6.43-8.17.79-6.24 12.67.32 14.28z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ab)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-141",
    d: "M173.42 185.35c.44.56 4.22 2.32 4.27 2.34 2.9 1 5.08-.66 7-2.64 2.82-2.88-.1-7.85-3.77-10.11-6.27-3.87-11.33 5.7-7.5 10.41z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ac)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-142",
    d: "M153.48 278a23.3 23.3 0 003.66 1.63c2.45.61 4.13-.87 5.59-2.63 2.13-2.55-.6-6.44-3.76-8.05-5.42-2.8-8.97 5.39-5.49 9.05z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ad)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-143",
    d: "M304.79 295.69a27.21 27.21 0 004.22 1.79c2.8.65 4.7-1.08 6.33-3.11 2.38-3-.81-7.35-4.46-9.13-6.24-3.05-10.11 6.38-6.09 10.45z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ae)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-144",
    d: "M114.32 117a26.3 26.3 0 001.07 4.35c1.14 2.57 3.61 3 6.16 3.12 3.7.12 5.26-4.95 4.51-8.84-1.29-6.69-10.92-4.17-11.74 1.37z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__af)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-145",
    d: "M69.84 211.75a22.32 22.32 0 003 2.47c2.14 1.19 4.1.22 5.92-1.06 2.64-1.86 1.07-6.21-1.49-8.53-4.37-3.97-9.76 2.84-7.43 7.12z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ag)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-146",
    d: "M213.74 296.28a26.3 26.3 0 001.31 4.32c1.29 2.53 3.79 2.87 6.36 2.82 3.74-.08 5-5.26 4.08-9.14-1.65-6.65-11.22-3.61-11.75 2z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ah)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-147",
    d: "M128.24 335.76a21 21 0 00.94 3.48c1 2.05 3 2.38 5 2.41 3 0 4.15-4.08 3.48-7.2-1.14-5.35-8.86-3.16-9.42 1.31z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ai)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-148",
    d: "M238.32 308.1a23.84 23.84 0 002.48 3.08c1.87 1.63 4 1.08 6.08.2 3-1.29 2.37-5.92.32-8.75-3.52-4.86-10.28.74-8.88 5.47z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__aj)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-149",
    d: "M207 215.41a16.28 16.28 0 002.26 1.67c1.58.79 3 0 4.22-1 1.84-1.43.56-4.5-1.36-6.08-3.27-2.67-6.92 2.41-5.12 5.41z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ak)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-150",
    d: "M103.65 243a26.4 26.4 0 001.45 4.51c1.38 2.62 4 2.94 6.71 2.84 3.92-.15 5.19-5.6 4.12-9.66-1.84-6.93-11.82-3.57-12.28 2.31z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__al)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-151",
    d: "M92.67 287.22a22.65 22.65 0 003.77.48c2.37-.12 3.49-1.93 4.33-3.92 1.22-2.89-2.31-5.66-5.61-6.25-5.67-1.01-6.61 7.37-2.49 9.69z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__am)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-152",
    d: "M123.53 90.6a25.08 25.08 0 003.28 2.9c2.34 1.43 4.57.44 6.67-.91 3-2 1.48-6.9-1.29-9.61-4.73-4.64-11.07 2.73-8.66 7.62z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__an)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-153",
    d: "M96.65 137.63a14.19 14.19 0 001.94 1.66c1.38.81 2.67.21 3.87-.6 1.76-1.17.8-4-.84-5.58-2.81-2.66-6.42 1.7-4.97 4.52z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ao)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-154",
    d: "M174.91 143.05a15.64 15.64 0 002.54-.05c1.56-.31 2.13-1.61 2.5-3 .53-2-2.07-3.53-4.32-3.6-3.84-.14-3.63 5.5-.72 6.65z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ap)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-155",
    d: "M95.69 220.6a26.64 26.64 0 004.52 1.4c3 .38 4.72-1.6 6.19-3.86 2.14-3.29-1.6-7.47-5.54-8.92-6.74-2.49-9.73 7.61-5.17 11.38z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__aq)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-156",
    d: "M145.86 187.89a20 20 0 002 2.7c1.51 1.45 3.35 1.07 5.13.41 2.59-1 2.23-4.91.61-7.38-2.81-4.24-8.74.22-7.74 4.27z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ar)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-157",
    d: "M252.22 119.74a16 16 0 001.84 1.72c1.33.86 2.63.32 3.85-.42 1.78-1.08 1-4-.59-5.55-2.65-2.74-6.41 1.4-5.1 4.25z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__as)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-158",
    d: "M27.24 184.42a13.32 13.32 0 001.45 2c1.11 1 2.44.76 3.74.27 1.87-.72 1.59-3.58.4-5.37-2.05-3.12-6.34.17-5.59 3.1z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__at)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-159",
    d: "M281.86 330.9a21.79 21.79 0 001.19 3.44c1.12 2 3.15 2.19 5.22 2.07 3-.17 3.9-4.39 3-7.49-1.53-5.31-9.15-2.56-9.41 1.98z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__au)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-160",
    d: "M55 279c.18.76 3.07 4.31 3.11 4.35 2.39 2.34 5.32 1.77 8.19.74 4.16-1.5 3.65-7.81 1.1-11.79-4.4-6.87-13.98.16-12.4 6.7z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__av)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-161",
    d: "M192.64 111.71a24.53 24.53 0 002.5 3.16c1.9 1.67 4.08 1.14 6.2.25 3.08-1.28 2.46-6 .4-8.92-3.55-4.98-10.49.68-9.1 5.51z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__aw)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-162",
    d: "M191.85 320.79a18.15 18.15 0 003.25-.1c2-.41 2.7-2.09 3.15-3.88.65-2.61-2.71-4.49-5.58-4.55-4.93-.11-4.61 7.11-.82 8.53z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ax)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-163",
    d: "M176.9 84.93c.32.72 3.86 3.73 3.91 3.76 2.83 1.9 5.65.78 8.32-.78 3.87-2.27 2.19-8.48-1.09-12-5.63-5.98-13.88 2.82-11.14 9.02z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__ay)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-164",
    d: "M252.65 335.65a18.67 18.67 0 002.64 1.72c1.81.76 3.3-.18 4.64-1.36 2-1.72.32-5.06-1.93-6.7-3.86-2.8-7.59 3.12-5.35 6.34z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__az)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-165",
    d: "M178.71 262.52c.15.74 2.86 4.26 2.89 4.3 2.26 2.33 5.12 1.86 7.92.93 4.07-1.34 3.75-7.47 1.39-11.39-4.06-6.74-13.52-.17-12.2 6.16z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__aA)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-166",
    d: "M149 361.92a26.13 26.13 0 003 3.45c2.21 1.8 4.66 1.09 7 0 3.41-1.59 2.5-6.9 0-10.08-4.27-5.47-11.85 1.24-10 6.63z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__aB)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "pink-circle-dots_svg__cls-167",
    d: "M243.43 155.29a17.49 17.49 0 002.78-.22c1.7-.45 2.23-1.92 2.54-3.48.45-2.27-2.52-3.74-5-3.67-4.22.08-3.65 6.31-.32 7.37z",
    transform: "translate(-565.189 -554.456)",
    fill: "url(#pink-circle-dots_svg__aC)"
  })));
}

export default __webpack_public_path__ + "static/pink-circle-dots.83ed40cc.svg";
export { SvgPinkCircleDots as ReactComponent };